import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/cliente';
import { Cargando } from '@/shared/ui/Cargando';
import { enDinero } from '@/shared/ui/graficos';

interface Cuenta {
  cuenta: string;
  contrato: string | null;
  cliente: string;
  identificacion: string;
  parroquia: string;
  direccion: string | null;
  motivo: string | null;
  fecha: string;
  deuda: number;
}

export function CuentasInactivas() {
  const cuentas = useQuery({
    queryKey: ['informe-cuentas-inactivas'],
    queryFn: () => api.get<Cuenta[]>('/informes/catastro/cuentas-inactivas/lista'),
  });

  if (cuentas.isLoading) {
    return <Cargando titulo="Cargando" detalle="buscando las cuentas dadas de baja" />;
  }
  const lista = cuentas.data ?? [];
  if (lista.length === 0) {
    return (
      <p className="p-6 text-center text-xs uppercase text-armazon-400">
        No hay cuentas dadas de baja
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-armazon-50/80">
          <tr>
            {['Cuenta', 'Titular', 'Parroquia', 'Motivo', 'Baja', 'Deuda'].map((c, i) => (
              <th
                key={c}
                scope="col"
                className={`px-3 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-armazon-500 ${
                  i === 5 ? 'text-right' : 'text-left'
                }`}
              >
                {c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-armazon-100">
          {lista.map((c) => (
            <tr key={c.cuenta} className="align-top transition-colors hover:bg-armazon-50/60">
              <td className="px-3 py-2.5">
                <span className="importe block text-xs font-semibold">{c.cuenta}</span>
                {c.contrato && (
                  <span className="importe block text-[10px] text-armazon-400">{c.contrato}</span>
                )}
              </td>
              <td className="px-3 py-2.5">
                <span className="block text-xs uppercase text-armazon-800">{c.cliente}</span>
                <span className="importe block text-[10px] text-armazon-400">
                  {c.identificacion}
                </span>
              </td>
              <td className="px-3 py-2.5 text-xs uppercase text-armazon-600">
                {c.parroquia}
                {c.direccion && (
                  <span className="block text-[10px] text-armazon-400">{c.direccion}</span>
                )}
              </td>
              <td className="max-w-md px-3 py-2.5 text-[11px] uppercase leading-relaxed text-armazon-700">
                {c.motivo ?? '—'}
              </td>
              <td className="importe px-3 py-2.5 text-xs">{c.fecha}</td>
              <td
                className={`importe px-3 py-2.5 text-right text-xs ${c.deuda > 0 ? 'font-bold text-amber-700' : 'text-armazon-400'}`}
              >
                {c.deuda > 0 ? enDinero(c.deuda) : '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
